import { render, staticRenderFns } from "./key-value-unit-blood-oxygen-report.vue?vue&type=template&id=62f9213b"
import script from "./key-value-unit-blood-oxygen-report.vue?vue&type=script&lang=js"
export * from "./key-value-unit-blood-oxygen-report.vue?vue&type=script&lang=js"
import style0 from "./key-value-unit-blood-oxygen-report.vue?vue&type=style&index=0&id=62f9213b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports